import 'styles/globals.css'
import 'focus-visible'
import React from 'react'
import { render } from 'react-snapshot'
import { RouterProvider } from 'react-router-dom'
import { router } from 'router'
import { reportWebVitals } from 'reportWebVitals'
import { initTopLevelClickHandling } from 'utils/top-level-handler'

initTopLevelClickHandling()

render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.info))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
